import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";

// TODO: UPDATE THIS TO CONTEMPLATE NEW MODEL
// Authenication Higher Order Component
// if the authenticated, it proceeds. If not, auto routes to welcome page
// 'auth_level' property specifies
//    - "guest"   - anyone who was issued an authentication token (note: when guest users
//                  first join a call, or do solo recording, the system will also issue
//                  them a token so they can do certain actions with the platform)
//    - "user"    - any logged on user
//    - "manager" - manager of organization (or admin who is by default manager for all)
//    - "org_manager" - manager of organization (UPDATE description)
//    - "admin"   - global site admin
// If 'auth_level' is not provided, default access level is 'user'.

export function RequireAuth({
  children,
  authLevel = "user",
}: {
  children: JSX.Element;
  authLevel?: "guest" | "user" | "manager" | "org_manager" | "admin";
}) {
  const { authenticated, role } = useSelector((state) => ({
    authenticated: state.auth.authenticated,
    role: state.auth.role,
  }));

  if (!authenticated || (authLevel !== "guest" && role === "guest")) {
    return <Navigate to="/welcome" />;
  } else if (
    (authLevel === "admin" && role !== "admin") ||
    (authLevel === "org_manager" && role !== "admin" && role !== "org_manager") ||
    (authLevel === "manager" && role !== "admin" && role !== "org_manager" && role !== "manager") ||
    (authLevel === "user" && role === "guest")
  ) {
    return <Navigate to="/" />;
  } else {
    return children;
  }
}
